import Vue from 'vue'
import Vuex from 'vuex'
import articles from './modules/articles'
import categories from './modules/categories'
import gameHubs from './modules/gameHubs'

Vue.use(Vuex)

export default function createStore() {
  return new Vuex.Store({
    state: {
      siteConfig: {
        name: 'GamesNest',
        domain: 'gamesnest.org',
        description: 'Your source for gaming news, reviews, guides and deals',
      },
    },
    modules: {
      articles,
      categories,
      gameHubs,
    },
  })
}
